/**
 * Attribute glossary (doc-comment equivalent for the manifest's enrichment
 * fields) — Layer 1 of the detail-page documentation work: what a concept
 * means, defined once per attribute name, shared across every instance of
 * that kind. Rendered via InlineHelp next to each EnrichmentFields label.
 */

export const SURFACE_ATTRIBUTE_DOCS: Record<string, string> = {
  personas: 'Which user personas this surface is designed for.',
  conditionalLogic: 'Business rules controlling when this surface renders or hides.',
  a11yNotes: 'Accessibility considerations specific to this surface.',
};

export const CLOUD_FUNCTION_ATTRIBUTE_DOCS: Record<string, string> = {
  rationale: 'Why this function exists — the business reasoning behind it.',
  triggerCondition: 'What causes this function to run.',
  slaMs: 'Maximum expected response time, in milliseconds.',
  retryPolicy: 'How failed invocations of this function are retried.',
  authRequired: 'Whether callers of this function must be authenticated.',
};

export const EVENT_TYPE_ATTRIBUTE_DOCS: Record<string, string> = {
  requiresDualWrite: 'Must be written to both the audit trail and the operational store.',
  retentionDays: 'How many days this event is retained before deletion.',
  businessTrigger: 'The real-world action or condition that causes this event to fire.',
  lifecycle: "Which stage of an object's lifecycle this event represents.",
};

export const FIRESTORE_PATH_ATTRIBUTE_DOCS: Record<string, string> = {
  owner: "The team or system responsible for this path's data.",
  accessPatterns: 'How this path is typically read or queried.',
  writeOwner: 'Whether the client, server, or both write to this path.',
  quotaNotes: 'Rate-limit or storage-quota considerations for this path.',
  migrationNotes: 'Known migration history or planned schema changes for this path.',
  compliance: "Regulatory requirements that apply to this path's data.",
};
